import * as React from 'react';
import classNames from 'classnames';
import { CnPageFooter } from '@/components/cn-page-footer';
import { withNativeProps } from '@/utils/with-native-props';
import { getComponentName } from '@/utils/get-component-name';
import { getWindowData } from '@/utils/get-window-data';
import Div100vh from './height';
function autoAddPageLayout() {
    try {
        document.documentElement.classList.add('cn-ui-m-page-layout');
    }
    catch { }
}
/**
 * @category 组件
 * @description 页面容器
 */
export const CnPage = (props) => {
    autoAddPageLayout();
    const { children: childrenProps, noPadding, footer: footerProps = null, } = props;
    const footer = React.useMemo(() => {
        if (!footerProps)
            return null;
        if (getComponentName(footerProps) === 'CnPageFooter')
            return footerProps;
        return React.createElement(CnPageFooter, null, footerProps);
    }, [footerProps]);
    const headerHasMount = React.useRef(Boolean(document.querySelector('.cn-ui-m-shell-header')));
    const { headerChildren, contentChildren } = React.useMemo(() => {
        const temp = {
            headerChildren: [
                headerHasMount.current ? null : getWindowData('__CNUI_shellHeader'),
            ],
            contentChildren: [],
        };
        React.Children.forEach(childrenProps, (childrenItem) => {
            if (!React.isValidElement(childrenItem)) {
                temp.contentChildren.push(childrenItem);
                return;
            }
            const type = getComponentName(childrenItem) || '';
            if (['CnFilter', 'CnFilterPro'].includes(type)) {
                temp.headerChildren.push(childrenItem);
            }
            else {
                temp.contentChildren.push(childrenItem);
            }
        });
        return temp;
    }, [childrenProps]);
    const { hasCnTab, hasCnFilter } = React.useMemo(() => {
        const temp = {
            hasCnTab: false,
            hasCnFilter: false,
        };
        React.Children.forEach(contentChildren, (child) => {
            if (!React.isValidElement(child))
                return;
            const { displayName } = child.type;
            if (displayName === 'CnTab') {
                temp.hasCnTab = true;
            }
            if (displayName === 'CnFilter') {
                temp.hasCnFilter = true;
            }
        });
        return temp;
    }, [contentChildren]);
    const className = classNames('cn-ui-m-page-content', {
        'cn-ui-m-page-content-padding': !noPadding,
        'cn-ui-m-page-content-children-padding': !noPadding && (hasCnFilter || hasCnTab),
        'cn-ui-m-page-content-children-has-cn-tab': hasCnTab,
    });
    return (React.createElement(Div100vh, { className: "cn-ui-m-page" },
        React.createElement("div", { className: "cn-ui-m-page-body" },
            headerChildren,
            withNativeProps(props, React.createElement("div", { className: className }, contentChildren))),
        footer,
        React.createElement("div", { className: "cn-ui-m-page-footer-placeholder" })));
};
